/**
 * Shared shipment status constants and lists
 * Used across multiple report components to avoid duplication
 */

// Complete shipment status list for general reports
//disable eslint
/* eslint-disable */

export const SHIPMENT_STATUS_LIST = [
    { value: "ATTEMPTED", label: "Attempted" },
    { value: "BAG_CREATED", label: "Bag Created" },
    { value: "BAG_DELETED", label: "Bag Deleted" },
    { value: "BAG_FINALISED", label: "Bag Finalised" },
    { value: "BAGGED", label: "Bagged" },
    { value: "BOOKED", label: "Booked" },
    { value: "CF_NEXT_DAY", label: "CF Next Day" },
    { value: "COMPLETED", label: "Completed" },
    { value: "DAMAGED", label: "Damaged" },
    { value: "DELIVERED", label: "Delivered" },
    { value: "DELIVERY_FAILED", label: "Delivery Failed" },
    { value: "DESTROYED", label: "Destroyed" },
    { value: "DISCARDED", label: "Discarded" },
    { value: "DRSGENERATED", label: "DRS Generated" },
    { value: "EXCESS_INSCAN", label: "Excess Inscan" },
    { value: "FORCE_BAG", label: "Force Bag" },
    { value: "HUB-IN-SCANNED", label: "Hub In-Scanned" },
    { value: "HUB-OUTSCAN", label: "Hub Outscan" },
    { value: "IN-BAG-INSCAN", label: "In-Bag Inscan" },
    { value: "IN-BAG-OUTSCAN", label: "In-Bag Outscan" },
    { value: "INSCANNED", label: "Inscanned" },
    { value: "INSCANNED_AT_CP", label: "Inscanned at CP" },
    { value: "INSCANNED_AT_TRANSIT", label: "Inscanned at Transit" },
    { value: "LCR-INSCAN", label: "LCR Inscan" },
    { value: "MANIFESTED", label: "Manifested" },
    { value: "MANIFESTED_FOR_CP", label: "Manifested for CP" },
    { value: "MIS_ROUTED", label: "Mis Routed" },
    { value: "MODE_AUDITED", label: "Mode Audited" },
    { value: "OUT_FOR_DELIVERY", label: "Out for Delivery" },
    { value: "OUT_SCAN_TO_CP", label: "Out Scan to CP" },
    { value: "PINCODE_AUDITED", label: "Pincode Audited" },
    { value: "REMOVED_FROM_LCR", label: "Removed from LCR" },
    { value: "REROUTED", label: "Rerouted" },
    { value: "RETURN", label: "Return" },
    { value: "RETURN_DELIVERED", label: "Return Delivered" },
    { value: "RETURN_INITIATED", label: "Return Initiated" },
    { value: "RETURN_REVOKED", label: "Return Revoked" },
    { value: "RTO_DELIVERED", label: "RTO Delivered" },
    { value: "RTO_OUT_FOR_DELIVERY", label: "RTO Out for Delivery" },
    { value: "SORTED", label: "Sorted" },
    { value: "TERMINATED", label: "Terminated" },
    { value: "UPDATED_BOOKING", label: "Updated Booking" },
    { value: "WEIGHT_AUDITED", label: "Weight Audited" }
];

// LCR-specific status list for LCR reports
export const LCR_STATUS_LIST = [
    { value: "LCR-INSCAN", label: "LCR Inscan" },
    { value: "LCR-OUTSCAN", label: "LCR Outscan" },
    { value: "COMPLETED", label: "Completed" },
    { value: "BOOKED", label: "Booked" },
    { value: "HUB-IN-SCANNED", label: "Hub In-Scanned" },
    { value: "HUB-OUTSCAN", label: "Hub Outscan" }
];

// Delivery Status Report specific list
export const DELIVERY_REPORT_STATUS_LIST = [
    { value: "RETURN_REVOKED", label: "Return Revoked" },
    { value: "FORCE_BAG_ATTEMPTED", label: "Force Bag Attempted" },
    { value: "REROUTED", label: "Rerouted" },
    { value: "BAGGED", label: "Bagged" },
    { value: "OUT_SCAN_TO_3PL", label: "Out Scan To 3PL" },
    { value: "UNDELIVERED", label: "Undelivered" },
    { value: "INSCANNED_AT_CP", label: "Inscanned At CP" },
    { value: "MANIFESTED", label: "Manifested" },
    { value: "HUB-OUTSCAN", label: "Hub Outscan" },
    { value: "HUB-IN-SCANNED", label: "Hub In Scanned" },
    { value: "FORCE_BAG", label: "Force Bag" },
    { value: "DAMAGED", label: "Damaged" },
    { value: "OUT_FOR_DELIVERY", label: "Out For Delivery" },
    { value: "IN_BAG_OUTSCAN_TO_CP", label: "In Bag Outscan To CP" },
    { value: "SCHEDULED_FOR_TRIP", label: "Scheduled For Trip" },
    { value: "UPDATED_BOOKING", label: "Updated Booking" },
    { value: "IN-BAG-OUTSCAN", label: "In Bag Outscan" },
    { value: "RTO_OUT_FOR_DELIVERY", label: "RTO Out For Delivery" },
    { value: "RTO_DELIVERED", label: "RTO Delivered" },
    { value: "IN-BAG-INSCAN", label: "In Bag Inscan" },
    { value: "OUT_SCAN_TO_CP", label: "Out Scan To CP" },
    { value: "FORCE_HUB_OUTSCAN", label: "Force Hub Outscan" },
    { value: "INSCANNED", label: "Inscanned" },
    { value: "MIS_ROUTED", label: "Mis Routed" },
    { value: "RETURN_INITIATED", label: "Return Initiated" },
    { value: "INSCANNED_AT_TRANSIT", label: "Inscanned At Transit" },
    { value: "DELIVERED", label: "Delivered" }
];

// Status mapping for display purposes
export const STATUS_DISPLAY_MAP = {
    "RETURN": "Return",
    "CF_NEXT_DAY": "CF Next Day",
    "RTO_DELIVERED": "RTO Delivered",
    "RETURN_DELIVERED": "Return Delivered",
    "RETURN_INITIATED": "Return Initiated",
    "DESTROYED": "Destroyed",
    "DELIVERY_FAILED": "Delivery Failed",
    "DELIVERED": "Delivered",
    "OUT_FOR_DELIVERY": "Out for Delivery",
    "DRSGENERATED": "DRS Generated",
    "INSCANNED_AT_CP": "Inscanned at CP",
    "MANIFESTED_FOR_CP": "Manifested for CP",
    "OUT_SCAN_TO_CP": "Out Scan to CP",
    "SORTED": "Sorted",
    "MANIFESTED": "Manifested",
    "COMPLETED": "Completed",
    "BOOKED": "Booked",
    "HUB-OUTSCAN": "Hub Outscan",
    "HUB-IN-SCANNED": "Hub In-Scanned",
    "PINCODE_AUDITED": "Pincode Audited",
    "INSCANNED": "Inscanned",
    "EXCESS_INSCAN": "Excess Inscan",
    "UPDATED_BOOKING": "Updated Booking",
    "BAG_CREATED": "Bag Created",
    "BAG_FINALISED": "Bag Finalised",
    "INSCANNED_AT_TRANSIT": "Inscanned at Transit",
    "BAGGED": "Bagged",
    "LCR-INSCAN": "LCR Inscan",
    "BAG_DELETED": "Bag Deleted",
    "DAMAGED": "Damaged",
    "TERMINATED": "Terminated",
    "MIS_ROUTED": "Mis Routed",
    "DISCARDED": "Discarded",
    "REROUTED": "Rerouted",
    "MODE_AUDITED": "Mode Audited",
    "WEIGHT_AUDITED": "Weight Audited",
    "REMOVED_FROM_LCR": "Removed from LCR",
    "RETURN_REVOKED": "Return Revoked",
    "RTO_OUT_FOR_DELIVERY": "RTO Out for Delivery",
    "ATTEMPTED": "Attempted",
    "IN-BAG-INSCAN": "In-Bag Inscan",
    "IN-BAG-OUTSCAN": "In-Bag Outscan",
    "FORCE_BAG": "Force Bag"
};

// Helper function to get status display text
export const getStatusDisplayText = (status) => {
    return STATUS_DISPLAY_MAP[status] || status;
};
